const SESSION_STORAGE_KEY = "homescout_session_id";

// crypto.randomUUID() is only available in secure contexts (HTTPS or localhost) —
// falls back to crypto.getRandomValues (no such restriction), then Math.random,
// so session ids still work when the app is opened over plain HTTP on a LAN IP.
function generateUuid(): string {
  if (typeof window.crypto?.randomUUID === "function") {
    return window.crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof window.crypto?.getRandomValues === "function") {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10

  const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
}

export function getOrCreateSessionId(): string {
  const existing = window.sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (existing) return existing;

  const sessionId = generateUuid();
  window.sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
  return sessionId;
}

export interface ActionEvent {
  sessionId: string;
  userId?: string | null;
  timestamp: string;
  actionName: string;
  type: string;
  properties?: string | null;
}

export class ActionsApi {
  constructor(private apiBaseUrl: string) {}

  async sendActions(events: ActionEvent[]): Promise<void> {
    const response = await fetch(`${this.apiBaseUrl}/api/actions`, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(events),
    });

    if (!response.ok) {
      throw new Error(`Failed to send actions: ${response.statusText}`);
    }
  }
}
